import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=53813085&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=53813085&prod&scoped=true&lang=css"
import style1 from "./paymentPage.vue?vue&type=style&index=1&id=53813085&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53813085",
  null
  
)

export default component.exports